{
    "name": "hip-ama-aurora-front",
    "version": "0.2.0",
    "description": "Hip Ama Aurora Frontend",
    "author": "",
    "license": "",
    "private": true,
    "scripts": {
        "ng": "ng",
        "start": "ng serve",
        "start:dev": "node ./node_modules/@angular/cli/bin/ng serve  --configuration=development",
        "start:azure-dev": "node ./node_modules/@angular/cli/bin/ng serve  --configuration=azure-dev",
        "start:azure-prod": "node ./node_modules/@angular/cli/bin/ng serve  --configuration=azure-prod",
        "start:local": "node ./node_modules/@angular/cli/bin/ng serve --configuration=localhost",
        "build": "ng build",
        "watch": "ng build --watch --configuration development",
        "test": "ng test"
    },
    "dependencies": {
        "@angular/animations": "19.0.5",
        "@angular/cdk": "19.0.4",
        "@angular/common": "19.0.5",
        "@angular/compiler": "19.0.5",
        "@angular/core": "19.0.5",
        "@angular/forms": "19.0.5",
        "@angular/material": "19.0.4",
        "@angular/material-luxon-adapter": "19.0.4",
        "@angular/platform-browser": "19.0.5",
        "@angular/platform-browser-dynamic": "19.0.5",
        "@angular/router": "19.0.5",
        "@apollo/client": "^3.13.4",
        "@azure/msal-angular": "^4.0.10",
        "@azure/msal-browser": "^4.11.0",
        "@jsverse/transloco": "7.5.1",
        "@ng-matero/extensions": "18.1.3",
        "@rxweb/reactive-form-validators": "^13.0.1",
        "apexcharts": "3.49.1",
        "apollo-angular": "^10.0.3",
        "apollo-upload-client": "^18.0.1",
        "cropperjs": "^1.6.2",
        "crypto-js": "4.2.0",
        "dayjs": "^1.11.13",
        "file-saver": "^2.0.5",
        "flag-icons": "^7.3.2",
        "generate-password-browser": "^1.1.0",
        "graphql": "^16.10.0",
        "highlight.js": "11.11.1",
        "libphonenumber-js": "^1.12.6",
        "lodash-es": "^4.17.21",
        "luxon": "3.5.0",
        "marked": "^15.0.7",
        "ng-apexcharts": "1.15.0",
        "ngx-file-drop": "^16.0.0",
        "ngx-json-viewer": "^3.2.1",
        "ngx-mat-select-search": "^8.0.0",
        "ngx-quill": "27.0.0",
        "perfect-scrollbar": "1.5.6",
        "quill": "2.0.3",
        "rxjs": "7.8.1",
        "swiper": "^11.2.8",
        "tslib": "2.8.1",
        "xlsx": "^0.18.5",
        "zone.js": "0.15.0"
    },
    "devDependencies": {
        "@angular-devkit/build-angular": "19.0.6",
        "@angular/cli": "19.0.6",
        "@angular/compiler-cli": "19.0.5",
        "@tailwindcss/typography": "0.5.15",
        "@types/chroma-js": "2.4.5",
        "@types/crypto-js": "4.2.2",
        "@types/file-saver": "^2.0.7",
        "@types/highlight.js": "10.1.0",
        "@types/jasmine": "5.1.5",
        "@types/lodash": "4.17.13",
        "@types/lodash-es": "4.17.12",
        "@types/luxon": "3.4.2",
        "autoprefixer": "10.4.20",
        "chroma-js": "2.4.2",
        "jasmine-core": "5.1.2",
        "karma": "6.4.4",
        "karma-chrome-launcher": "3.2.0",
        "karma-coverage": "2.2.1",
        "karma-jasmine": "5.1.0",
        "karma-jasmine-html-reporter": "2.1.0",
        "lodash": "4.17.21",
        "postcss": "8.4.49",
        "prettier": "3.4.2",
        "prettier-plugin-organize-imports": "4.1.0",
        "prettier-plugin-tailwindcss": "0.6.9",
        "tailwindcss": "3.4.17",
        "typescript": "5.6.3"
    }
}
